$(function() {
    var SPMaskBehavior = function (val) {
        return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
      },
      spOptions = {
        onKeyPress: function(val, e, field, options) {
            field.mask(SPMaskBehavior.apply({}, arguments), options);
          }
      };
      
      $('.wpcf7-tel').mask(SPMaskBehavior, spOptions);
      $('#calc_shipping_postcode_field .input-text').mask('00000-000');
      $('.billing_postcode').mask('00000-000');
      $('#billing_cpf').mask('000.000.000-00');
      $('#billing_cnpj').mask('00.000.000/0000-00');
});
